import { Root } from '../ReportMailingForm/components/Root';
import { Label, Recipients } from './components';

export const RecipientGroupForm = {
  Root,
  Label,
  Recipients,
};
